const getConfig = () => {
  return {
    publicRuntimeConfig: window.config || import.meta.env || {}
  };
};

export default getConfig;
